import gql from 'graphql-tag';

export const CHANGE_PASSWORD = gql`
  mutation changePassword($passwordChange: ChangePasswordInput!) {
    changePassword(input: $passwordChange) {
      ... on ChangePasswordSuccess {
        ref
      }
      ... on ChangePasswordFailure {
        error {
          __typename
          message
          code
          reason
          ... on AccountValidationError {
            details {
              message
              code
              path {
                field
                path
              }
              reason
            }
          }
        }
      }
    }
  }
`;
